import * as types from "./actionTypes";
import constants from "../../configs/constants";
import cag_airline_code_mapping_csv from "../../assets/data/cag_airline_code_mapping.csv";
import aircraft_bay_pushback_mapping_csv from "../../assets/data/aircraft_bay_pushback_mapping.csv";
import pb_restriction_csv from "../../assets/data/aircraft_bay_pushback_mapping.csv";
import {
  CognitoUserPool,
} from "amazon-cognito-identity-js";

const Papa = require("papaparse");

export const restoreSession = () => {
  return dispatch => {
    if (constants.DEBUG) {
      console.log("restoring session...");
    }
    dispatch({ type: types.RESTORE_SESSION_REQUEST });
    Papa.parse(aircraft_bay_pushback_mapping_csv, {
      download: true,
      header: true,
      complete: function(aircraft_bay_pushback_mapping_json) {
        console.log(aircraft_bay_pushback_mapping_json);
        Papa.parse(cag_airline_code_mapping_csv, {
          download: true,
          header: true,
          complete: function(cag_airline_code_mapping_json) {
            console.log(cag_airline_code_mapping_json);
            let userPool = new CognitoUserPool({
              UserPoolId: "ap-southeast-1_A1xXOHSUr",
              ClientId: "1vcouum693adfsj1ih0ndbm01q"
            });

            dispatch({
              type: types.RESTORE_SESSION_SUCCESS,
              pushbackMapping: aircraft_bay_pushback_mapping_json,
              airlineCodeMapping: cag_airline_code_mapping_json,
              userPool
            });
          }
        });
      }
    });
  };
};

export const clearError = () => {
  return dispatch => {
    dispatch({ type: types.CLEAR_ERROR_REQUEST });
  };
};

export const updateUser = (user) => {
  return dispatch => {
    dispatch({ type: types.UPDATE_USER_REQUEST, user });
  };
};


export const getPbRestriction = () => {
  return dispatch => {
    Papa.parse(pb_restriction_csv, {
      download: true,
      header: true,
      complete: function(pbRestriction_json) {
        console.log("actions.js");
        console.log(pbRestriction_json);
        dispatch({
          type: types.GET_PB_RESTRICTION,
          pbRestrictionMapping: pbRestriction_json 
        });
      }
    })

  };
};

export const getSessionInfo = param => {
  return dispatch => {
    dispatch({ type: types.GET_SESSION_INFO });
    getSessionInfoFunc(param)
      .then(sessionInfo => {
        console.log("sessionInfo:", sessionInfo);
        dispatch({ type: types.GET_SESSION_SUCCESS, sessionInfo });
      })
      .catch(error => {
        dispatch({
          type: types.GET_SESSION_FAIL,
          error: error
        });
      });
  };
};

function getSessionInfoFunc(param) {
  let defer = new Promise((resolve, reject) => {  
    fetch(constants.GET_SESSION_INFO_API_URL, {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": constants.GET_SESSION_INFO_API_KEY
      },
      body: JSON.stringify(param)
    })
      .then(res => res.json())
      .then(
        result => {
          let returnData = [];
          console.log('result', result);
          if (result.AccessToken) {
            returnData = result;
          } else {
            reject(result);
          }
          resolve(returnData);
        },
        error => {
          reject(error);
        }
      );
  });
  return defer;
}

export const getKillSwitchInfo = param => {
  return dispatch => {
    dispatch({ type: types.GET_KILL_SWITCH_MESSAGE });
    getKillSwitchInfoFunc(param)
      .then(switchDataMessage => {
        console.log("switchDataMessage:", switchDataMessage);
        dispatch({ type: types.GET_KILL_SWITCH_MESSAGE_SUCCESS, switchDataMessage });
      })
      .catch(error => {
        dispatch({
          type: types.GET_KILL_SWITCH_MESSAGE_FAIL,
          error: error
        });
      });
  };
};

function getKillSwitchInfoFunc(param) {
  let defer = new Promise((resolve, reject) => {  
    fetch(constants.GET_KILL_SWITCH_API_URL, {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": constants.GET_KILL_SWITCH_API_KEY
      },
      body: JSON.stringify(param)
    })
      .then(res => res.json())
      .then(
        result => {
          let returnData = [];
          console.log('switchData result', result);
          console.log('switchData result', Array.isArray(result));

          if (Array.isArray(result)) {
            returnData = result[0];
          } else {
            // returnData = result
            reject(result)
          }
          
          resolve(returnData);
        },
        error => {
          reject(error);
        }
      );
  });
  return defer;
}

export const exportTokenInfo = param => {
  return dispatch => {
    dispatch({ type: types.ENCRYPT_TOKEN_REQUEST });
    exportTokenInfoFunc(param)
      .then(tokenInfo => {
        console.log("tokenInfo:", tokenInfo);
        dispatch({ type: types.ENCRYPT_TOKEN_SUCCESS, tokenInfo });
      })
      .catch(tokenInfoError => {
        dispatch({
          type: types.ENCRYPT_TOKEN_FAIL,
          tokenInfoError: 'Invalid token. Please reload the page again.'
          // tokenInfoError: tokenInfoError,
        });
      });
  };
};

function exportTokenInfoFunc(param) {
  let defer = new Promise((resolve, reject) => {  
    fetch(constants.ENCRYPT_TOKEN_API_URL, {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": constants.ENCRYPT_TOKEN_API_KEY
      },
      body: JSON.stringify(param)
    })
      .then(res => res.json())
      .then(
        result => {
          let returnData = [];
          console.log('result 1', result);
          if (result) {
            returnData = result;
            console.log('result 2', result);
          } else {
            reject(result);
            console.log('result 3', result);
          }
          resolve(returnData);
        },
        error => {
          reject(error);
        }
      );
  });
  return defer;
}